import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { ReactComponent as UnassignFromCollectionIcon } from "static/icons/minus-circle.svg";

import { unassignFromCollection } from "../../store/actions/collections";

import UniversalButton from "../uiComponents/UniversalButton";

const UnassignFromCollection = ({
  tableInfo,
  deleteSelectElements,
  unstyled,
}) => {
  const { t } = useTranslation();

  const dispatch = useDispatch();

  const { tabs } = useSelector((state) => state.table);

  const handleClickButton = async () => {
    await dispatch(unassignFromCollection({ ...tableInfo, tabs }));
    deleteSelectElements();
  };

  return (
    <UniversalButton
      style={{ height: "32px" }}
      label={t("unassign_selection")}
      size="md"
      labelColor="blue"
      labelHoverColor="blue"
      backgroundColor="blue"
      backgroundHoverColor="$blue"
      leftIcon={<UnassignFromCollectionIcon />}
      onClick={handleClickButton}
      isRounded="sm"
      unstyled={unstyled}
    />
  );
};

export default UnassignFromCollection;
